module.exports = __webpack_public_path__ + "static/img04-642fc4d479c8b590f368d45ec43fe04a.png";